import { QueryClient } from '@tanstack/react-query'

import { getActivityList } from '@/lib/api/services'

import { ACTIVITY_LIST_KEY } from '../explore/explore-prefetch'

/**
 * 预取 Apps 页面所需的数据
 * 在服务端组件中调用，数据会通过 HydrationBoundary 传递给客户端
 */
export async function prefetchAppsData(queryClient: QueryClient, pageSize = 20) {
  await queryClient.prefetchInfiniteQuery({
    queryKey: [ACTIVITY_LIST_KEY, pageSize],
    queryFn: async ({ pageParam = 0 }) => {
      return await getActivityList({ page: pageParam, pageSize })
    },
    initialPageParam: 0
  })
}
